import { faClock } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';

import styles from './QuickSetupMessage.module.scss';

const QuickSetupMessage: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div className={styles['setup-message']}>
      <FontAwesomeIcon icon={faClock} />
      <p>
        Setup takes just <b>2 minutes</b>
      </p>
    </div>
  );
};

export default QuickSetupMessage;
